module.exports = __webpack_public_path__ + "media/images/front/event_publish_lp/pagetitle_01-2f676b6f953fe0fc05732c74ef0a1712.png";